<template>
  <div class="caption">
    <RevTag
      v-if="withTag"
      :label="i18n(translations.example)"
      size="small"
      variant="secondary"
      variation="filled"
    />
    <div v-else>{{ i18n(translations.example) }}</div>
    <IconCamera v-if="withIcon" data-test="icon" size="16" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'
import { IconCamera } from '@ds/icons/IconCamera'

import translations from './ExampleImage.translations'

withDefaults(
  defineProps<{
    withIcon?: boolean
    withTag?: boolean
  }>(),
  {
    withIcon: true,
    withTag: false,
  },
)

const i18n = useI18n()
</script>
